<template>
  <div id="main">
    <form id="formDuplicate">
      <span>
        <label for="duplicateName">{{ $t("insight.name") }}</label>
        <b-input
        style="min-width:250px;"
          id="duplicateName"
          v-model="rowDuplicate.name"
          name="duplicateName"
          @focus="$event.target.select()"
        />
      </span>

      <b-checkbox
        v-if="outil === 'profeel'"
        v-model="parameters.proKeepInventory"
        >{{ $t("duplicate.parameter.results") }}</b-checkbox
      >

      <div class="popup-footer">
        <button
          @click.prevent="duplicateMeeting"
          type="is-success"
          class="is-success button"
        >
          {{ $t("button.validate") }}
        </button>
      </div>
    </form>
    <b-loading is-full-page :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PopupDuplicate",
  data() {
    return {
      isLoading: false,
      parameters: {
        eventKeepAttendees: false,
        eventKeepEvents: false,
        sondKeepAnswers: false,
        sondKeepQuestions: false,
        quizzKeepAnswers: false,
        quizzKeepQuestions: false,
        proKeepInventory: false,
        textKeepQuestions: false,
        brainKeepPostits: false,
      },
      rowDuplicate: JSON.parse(JSON.stringify(this.row)),
    };
  },
  props: {
    outil: String,
    row: Object,
  },
  created() {
    let date = new Date();
    this.rowDuplicate.name = `${this.rowDuplicate.name} (${this.$i18n.t(
      "meeting.duplicate.rename"
    )} ${date.getDate()}/${date.getMonth() +
      1} ${date.getHours()}:${date.getMinutes()})`;
  },
  methods: {
    duplicateMeeting() {
      this.isLoading = true;
      this.parameters.row = this.rowDuplicate;
      axios
        .post(
          `${process.env.VUE_APP_URL_SSO_API}Duplicate/${this.outil}/${this.rowDuplicate.url_moderateur}`,
          this.parameters
        )
        .then((response) => {
          this.$store.commit("MODAL_DUPLICATE", {
            insight: null,
            activeModalDuplicate: false,
          });
          this.$store.commit(`CLEAR_SEARCH`);
          this.$store.dispatch("getInsights");
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-success',
            message: this.$i18n.t('meeting.duplicate.success')
          })
        });
    },
  },
};
</script>

<style scoped>
#main {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column wrap;
}

#formDuplicate > * {
  margin: 5px;
  width: auto;
}

.submit_button {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  background-color: #23d160;
  color: white;
}

#formDuplicate {
  display: flex;
  flex-flow: column wrap;
  align-content: space-around;
}

h2 {
  font-weight: 600;
  padding: 10px;
}
.button {
  margin-top:20px;
  border-radius: 0px;
  font-size:12px;
}
</style>
